webpackJsonp([120937046367186],{

/***/ 270:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.13.4
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});var d=null,e=!1,g=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
	function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var f=g,Q=l;g=a;l=b;try{var h=c()}finally{g=f,l=Q}if("function"===typeof h)if(h={callback:h,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=h.next=h.previous=h;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=h,p());b=c.previous;b.next=c.previous=h;h.next=c;h.previous=
	b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=e;e=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,e=b,null!==d?p():n=!1,v()}}
	var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
	if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
	if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
	"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),f=!1;if(0>=P-c)if(-1!==b&&b<=c)f=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(f)}finally{O=!1}}};
	var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
	exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=g,f=k;g=a;k=exports.unstable_now();try{return b()}finally{g=c,k=f,v()}};exports.unstable_next=function(a){switch(g){case 1:case 2:case 3:var b=3;break;default:b=g}var c=g,f=k;g=b;k=exports.unstable_now();try{return a()}finally{g=c,k=f,v()}};
	exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(g){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:g,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var f=d;do{if(f.expirationTime>b){c=f;break}f=f.next}while(f!==d);null===c?c=d:c===d&&(d=a,p());
	b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=g;return function(){var c=g,f=k;g=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{g=c,k=f,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return g};
	exports.unstable_shouldYield=function(){return!e&&(null!==d&&d.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==d&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return d};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(270);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CloseIcon = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose([''], ['']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CloseIcon = exports.CloseIcon = function CloseIcon(props) {
	  return _react2.default.createElement(
	    'svg',
	    _extends({ viewBox: '-6.125 9.875 13.25 13.25' }, props),
	    _react2.default.createElement('path', {
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round',
	      d: 'M-5.102,22.12L6.102,10.916 '
	    }),
	    _react2.default.createElement('path', {
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round',
	      d: 'M6.102,22.12L-5.102,10.916 '
	    })
	  );
	};
	
	CloseIcon.displayName = 'CloseIcon';
	
	exports.default = (0, _styledComponents2.default)(CloseIcon)(_templateObject);

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n'], ['\n  display: flex;\n']);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _List = __webpack_require__(62);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var FlatList = (0, _styledComponents2.default)(_List2.default)(_templateObject);
	
	exports.default = FlatList;
	module.exports = exports['default'];

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  &:not(:last-child) {\n    margin-right: 0.5rem;\n  }\n'], ['\n  &:not(:last-child) {\n    margin-right: 0.5rem;\n  }\n']);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ListItem = __webpack_require__(63);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var FlatListItem = (0, _styledComponents2.default)(_ListItem2.default)(_templateObject);
	
	exports.default = FlatListItem;
	module.exports = exports['default'];

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(', ', 1fr));\n  grid-gap: 0.5rem;\n  grid-auto-rows: ', ';\n  grid-auto-flow: dense;\n'], ['\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(', ', 1fr));\n  grid-gap: 0.5rem;\n  grid-auto-rows: ', ';\n  grid-auto-flow: dense;\n']);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _List = __webpack_require__(62);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _utils = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Gallery = (0, _styledComponents2.default)(_List2.default)(_templateObject, (0, _utils.pxToRem)(300), (0, _utils.pxToRem)(260));
	
	exports.default = Gallery;
	module.exports = exports['default'];

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  z-index: 2;\n  padding: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  transition: transform 0.3s ease-in;\n  transform: translateY(100%);\n\n  @media (hover: none) {\n    transform: translateY(0);\n  }\n\n  p,\n  h4 {\n    margin-bottom: 0;\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n\n    background-color: ', ';\n    text-shadow: 0 0 1px rgba(255, 255, 255, 0.3);\n    font-weight: ', ';\n  }\n\n  h4 {\n    text-transform: uppercase;\n  }\n'], ['\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  z-index: 2;\n  padding: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  transition: transform 0.3s ease-in;\n  transform: translateY(100%);\n\n  @media (hover: none) {\n    transform: translateY(0);\n  }\n\n  p,\n  h4 {\n    margin-bottom: 0;\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n\n    background-color: ', ';\n    text-shadow: 0 0 1px rgba(255, 255, 255, 0.3);\n    font-weight: ', ';\n  }\n\n  h4 {\n    text-transform: uppercase;\n  }\n']);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _tinycolor = __webpack_require__(27);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _vars = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var GalleryCopy = _styledComponents2.default.div(_templateObject, (0, _tinycolor2.default)('#fff').setAlpha(0.6).toRgbString(), _vars.BODY_WEIGHTS.medium);
	
	exports.default = GalleryCopy;
	module.exports = exports['default'];

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n\n  &:not(:last-child) {\n    margin-bottom: 0;\n  }\n\n  .gatsby-image-outer-wrapper {\n    height: 100%;\n    width: 100%;\n  }\n\n  &:hover,\n  &:focus {\n    ', ' {\n      transform: translateY(0);\n    }\n  }\n'], ['\n  position: relative;\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n\n  &:not(:last-child) {\n    margin-bottom: 0;\n  }\n\n  .gatsby-image-outer-wrapper {\n    height: 100%;\n    width: 100%;\n  }\n\n  &:hover,\n  &:focus {\n    ', ' {\n      transform: translateY(0);\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _GalleryCopy = __webpack_require__(289);
	
	var _GalleryCopy2 = _interopRequireDefault(_GalleryCopy);
	
	var _propTypes = __webpack_require__(7);
	
	var CustomPropTypes = _interopRequireWildcard(_propTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var GalleryItem = function GalleryItem(_ref) {
	  var Tag = _ref.tag,
	      rest = _objectWithoutProperties(_ref, ['tag']);
	
	  return _react2.default.createElement(Tag, rest);
	};
	
	GalleryItem.displayName = 'GalleryItem';
	
	GalleryItem.propTypes = {
	  tag: CustomPropTypes.Tag
	};
	
	GalleryItem.defaultProps = {
	  tag: 'div'
	};
	
	exports.default = (0, _styledComponents2.default)(GalleryItem)(_templateObject, _GalleryCopy2.default);
	module.exports = exports['default'];

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  &:not(:last-child) {\n    margin-bottom: 0;\n  }\n'], ['\n  &:not(:last-child) {\n    margin-bottom: 0;\n  }\n']);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ListItem = __webpack_require__(63);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var GalleryItemWrapper = (0, _styledComponents2.default)(_ListItem2.default)(_templateObject);
	
	exports.default = GalleryItemWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.GalleryOverlay = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  height: 100%;\n'], ['\n  height: 100%;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: none;\n\n  @media (min-height: ', ') {\n    display: flex;\n  }\n\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: #000;\n  height: ', ';\n  overflow-x: scroll;\n  overflow-y: hidden;\n  transform: translateY(100%);\n\n  .gatsby-image-outer-wrapper {\n    position: absolute !important;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n  }\n\n  ', ' {\n    height: 100%;\n\n    div {\n      padding-bottom: 0 !important;\n    }\n  }\n'], ['\n  display: none;\n\n  @media (min-height: ', ') {\n    display: flex;\n  }\n\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: #000;\n  height: ', ';\n  overflow-x: scroll;\n  overflow-y: hidden;\n  transform: translateY(100%);\n\n  .gatsby-image-outer-wrapper {\n    position: absolute !important;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n  }\n\n  ', ' {\n    height: 100%;\n\n    div {\n      padding-bottom: 0 !important;\n    }\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  min-width: 150px;\n  &:not(:last-child) {\n    margin-right: 0;\n    margin-bottom: 0;\n  }\n'], ['\n  min-width: 150px;\n  &:not(:last-child) {\n    margin-right: 0;\n    margin-bottom: 0;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  z-index: 3;\n  top: 1rem;\n  right: 1rem;\n  width: ', ';\n  height: ', ';\n  background-color: rgba(0, 0, 0, 0.2);\n  padding: 0.5rem;\n\n  ', ' {\n    stroke: #fff;\n  }\n'], ['\n  position: absolute;\n  z-index: 3;\n  top: 1rem;\n  right: 1rem;\n  width: ', ';\n  height: ', ';\n  background-color: rgba(0, 0, 0, 0.2);\n  padding: 0.5rem;\n\n  ', ' {\n    stroke: #fff;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  height: 100%;\n  width: 100%;\n  position: relative;\n  border: 0.25rem solid transparent;\n\n  &[aria-pressed=\'true\'] {\n    border-color: #fff;\n\n    &:focus {\n      outline: none;\n    }\n  }\n'], ['\n  height: 100%;\n  width: 100%;\n  position: relative;\n  border: 0.25rem solid transparent;\n\n  &[aria-pressed=\'true\'] {\n    border-color: #fff;\n\n    &:focus {\n      outline: none;\n    }\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  max-width: ', ';\n  max-height: calc(100vh - ', ');\n  width: 100%;\n'], ['\n  display: flex;\n  flex-direction: column;\n  max-width: ', ';\n  max-height: calc(100vh - ', ');\n  width: 100%;\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  background-color: rgba(0, 0, 0, 0.95);\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  @media (min-height: ', ') {\n    bottom: ', ';\n  }\n'], ['\n  position: fixed;\n  background-color: rgba(0, 0, 0, 0.95);\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  @media (min-height: ', ') {\n    bottom: ', ';\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(127);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GatsbyImage = __webpack_require__(64);
	
	var _GatsbyImage2 = _interopRequireDefault(_GatsbyImage);
	
	var _FlatList = __webpack_require__(113);
	
	var _FlatList2 = _interopRequireDefault(_FlatList);
	
	var _FlatListItem = __webpack_require__(114);
	
	var _FlatListItem2 = _interopRequireDefault(_FlatListItem);
	
	var _InvisibleButton = __webpack_require__(121);
	
	var _InvisibleButton2 = _interopRequireDefault(_InvisibleButton);
	
	var _CloseIcon = __webpack_require__(129);
	
	var _CloseIcon2 = _interopRequireDefault(_CloseIcon);
	
	var _utils = __webpack_require__(6);
	
	var _propTypes3 = __webpack_require__(7);
	
	var CustomPropTypes = _interopRequireWildcard(_propTypes3);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var GalleryOverlayTileImageHeight = (0, _utils.pxToRem)(120);
	var GalleryOverlayPrimaryImage = (0, _styledComponents2.default)(_GatsbyImage2.default)(_templateObject);
	var GalleryOverviewList = (0, _styledComponents2.default)(_FlatList2.default)(_templateObject2, (0, _utils.pxToRem)(500), GalleryOverlayTileImageHeight, _GatsbyImage2.default);
	var GalleryOverviewListItem = (0, _styledComponents2.default)(_FlatListItem2.default)(_templateObject3);
	var GalleryOverviewCloseButton = (0, _styledComponents2.default)(_InvisibleButton2.default)(_templateObject4, (0, _utils.pxToRem)(30), (0, _utils.pxToRem)(30), _CloseIcon2.default);
	
	var GalleryTileButton = (0, _styledComponents2.default)(_InvisibleButton2.default)(_templateObject5);
	
	var GalleryInner = _styledComponents2.default.div(_templateObject6, (0, _utils.pxToRem)(1500), GalleryOverlayTileImageHeight);
	
	var GalleryOverlay = exports.GalleryOverlay = function (_React$Component) {
	  _inherits(GalleryOverlay, _React$Component);
	
	  function GalleryOverlay() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GalleryOverlay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { selectedIndex: _this.props.selectedIndex || 0 }, _this.handleSelectImageByIndex = function (selectedIndex) {
	      return function () {
	        _this.setState({ selectedIndex: selectedIndex });
	        if (_this.props.onSelectImage) {
	          _this.props.onSelectImage();
	        }
	      };
	    }, _this.handleResetSelection = function () {
	      _this.setState({ selectedIndex: null });
	      if (_this.props.onResetSelection) {
	        _this.props.onResetSelection();
	      }
	    }, _this.selectedImage = function () {
	      if (_this.state.selectedIndex === null) {
	        return {
	          sizes: {},
	          alt: ''
	        };
	      }
	
	      return _this.props.images[_this.state.selectedIndex];
	    }, _this.handleSelectLeft = function () {
	      if (_this.state.selectedIndex === 0) {
	        _this.setState({ selectedIndex: _this.props.images.length - 1 });
	      } else {
	        _this.setState(function (state) {
	          return {
	            selectedIndex: state.selectedIndex - 1
	          };
	        });
	      }
	    }, _this.handleSelectRight = function () {
	      if (_this.state.selectedIndex === _this.props.images.length - 1) {
	        _this.setState({ selectedIndex: 0 });
	      } else {
	        _this.setState(function (state) {
	          return {
	            selectedIndex: state.selectedIndex + 1
	          };
	        });
	      }
	    }, _this.handleKeyDown = function (event) {
	      if (event.keyCode === 27 && _this.props.onClose) {
	        _this.props.onClose();
	      } else if (event.keyCode === 39) {
	        _this.handleSelectRight();
	      } else if (event.keyCode === 37) {
	        _this.handleSelectLeft();
	      }
	    }, _this.scrollSelectedIntoView = function (elm) {
	      // eslint-disable-next-line react/no-find-dom-node
	      var node = _reactDom2.default.findDOMNode(elm);
	      if (node && node.scrollIntoView) {
	        node.scrollIntoView();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  GalleryOverlay.prototype.componentDidMount = function componentDidMount() {
	    document.addEventListener('keydown', this.handleKeyDown, false);
	  };
	
	  GalleryOverlay.prototype.componentWillUnmount = function componentWillUnmount() {
	    document.removeEventListener('keydown', this.handleKeyDown, false);
	  };
	
	  GalleryOverlay.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        Tag = _props.tag,
	        images = _props.images,
	        selectedIndex = _props.selectedIndex,
	        onResetSelection = _props.onResetSelection,
	        onSelectImage = _props.onSelectImage,
	        rest = _objectWithoutProperties(_props, ['tag', 'images', 'selectedIndex', 'onResetSelection', 'onSelectImage']);
	
	    var selectedImage = this.selectedImage();
	    return _react2.default.createElement(
	      Tag,
	      rest,
	      _react2.default.createElement(
	        GalleryInner,
	        null,
	        _react2.default.createElement(
	          GalleryOverviewCloseButton,
	          { onClick: this.handleResetSelection },
	          _react2.default.createElement(_CloseIcon2.default, null)
	        ),
	        _react2.default.createElement(GalleryOverlayPrimaryImage, { sizes: selectedImage.sizes, alt: selectedImage.alt })
	      ),
	      _react2.default.createElement(
	        GalleryOverviewList,
	        null,
	        images.map(function (image, i) {
	          return _react2.default.createElement(
	            GalleryOverviewListItem,
	            { key: image.id },
	            _react2.default.createElement(
	              GalleryTileButton,
	              {
	                onClick: _this2.handleSelectImageByIndex(i),
	                'aria-pressed': i === _this2.state.selectedIndex,
	                ref: i === _this2.state.selectedIndex && _this2.scrollSelectedIntoView
	              },
	              _react2.default.createElement(_GatsbyImage2.default, { sizes: image.sizes, alt: image.alt })
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return GalleryOverlay;
	}(_react2.default.Component);
	
	GalleryOverlay.displayName = 'GalleryOverlay';
	GalleryOverlay.propTypes = {
	  tag: CustomPropTypes.Tag,
	  images: _propTypes2.default.arrayOf(CustomPropTypes.ImageSharpWithAlt),
	  selectedIndex: _propTypes2.default.number,
	  onResetSelection: _propTypes2.default.func,
	  onSelectImage: _propTypes2.default.func,
	  onClose: _propTypes2.default.func
	};
	GalleryOverlay.defaultProps = {
	  tag: 'section',
	  images: []
	};
	exports.default = (0, _styledComponents2.default)(GalleryOverlay)(_templateObject7, (0, _utils.pxToRem)(500), GalleryOverlayTileImageHeight);

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Hero = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  transition: opacity 0.5s;\n  width: 100%;\n  height: 100%;\n'], ['\n  transition: opacity 0.5s;\n  width: 100%;\n  height: 100%;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  overflow: visible;\n  position: relative;\n  max-width: ', ';\n  margin-left: auto;\n  margin-right: auto;\n  @media (min-height: ', ') {\n    height: ', ';\n  }\n  max-height: ', ';\n\n  .gatsby-image-outer-wrapper {\n    position: absolute !important;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n  }\n'], ['\n  background-color: ', ';\n  overflow: visible;\n  position: relative;\n  max-width: ', ';\n  margin-left: auto;\n  margin-right: auto;\n  @media (min-height: ', ') {\n    height: ', ';\n  }\n  max-height: ', ';\n\n  .gatsby-image-outer-wrapper {\n    position: absolute !important;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(127);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _GatsbyImage = __webpack_require__(64);
	
	var _GatsbyImage2 = _interopRequireDefault(_GatsbyImage);
	
	var _propTypes3 = __webpack_require__(7);
	
	var CustomPropTypes = _interopRequireWildcard(_propTypes3);
	
	var _vars = __webpack_require__(5);
	
	var _utils = __webpack_require__(6);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var BackgroundImage = (0, _styledComponents2.default)(_GatsbyImage2.default)(_templateObject);
	
	var Hero = exports.Hero = function (_Component) {
	  _inherits(Hero, _Component);
	
	  function Hero() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Hero);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.componentDidUpdate = function (prevProps) {
	      var isFullHeight = _this.props.isFullHeight;
	
	      if (isFullHeight !== prevProps.isFullHeight && _this.elm && _this.elm.animate) {
	        if (isFullHeight) {
	          _this.elm.animate([{ height: '20vh' }, { height: '70vh' }], {
	            duration: 300,
	            fill: 'forwards',
	            easing: 'cubic-bezier(0.86, 0, 0.07, 1)',
	            iterations: 1
	          });
	        } else {
	          _this.elm.animate([{ height: '70vh' }, { height: '20vh' }], {
	            duration: 300,
	            fill: 'forwards',
	            easing: 'cubic-bezier(0.86, 0, 0.07, 1)',
	            iterations: 1
	          });
	        }
	      }
	    }, _this.setRef = function (elm) {
	      // eslint-disable-next-line react/no-find-dom-node
	      _this.elm = _reactDom2.default.findDOMNode(elm);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Hero.prototype.render = function render() {
	    var _props = this.props,
	        bgColor = _props.bgColor,
	        selectedImage = _props.selectedImage,
	        bgImages = _props.bgImages,
	        isFullHeight = _props.isFullHeight,
	        children = _props.children,
	        opacity = _props.opacity,
	        imgStyle = _props.imgStyle,
	        Tag = _props.tag,
	        rest = _objectWithoutProperties(_props, ['bgColor', 'selectedImage', 'bgImages', 'isFullHeight', 'children', 'opacity', 'imgStyle', 'tag']);
	
	    return _react2.default.createElement(
	      Tag,
	      _extends({ ref: this.setRef }, rest),
	      children,
	      bgImages.map(function (image) {
	        return _react2.default.createElement(BackgroundImage, {
	          key: image.sizes.src,
	          style: {
	            opacity: selectedImage.sizes.src === image.sizes.src ? '1' : '0'
	          },
	          sizes: image.sizes,
	          opacity: opacity,
	          imgStyle: imgStyle
	        });
	      })
	    );
	  };
	
	  return Hero;
	}(_react.Component);
	
	Hero.displayName = 'Hero';
	Hero.propTypes = {
	  tag: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	  children: _propTypes2.default.node,
	  isFullHeight: _propTypes2.default.bool,
	  selectedImage: CustomPropTypes.ImageSharp.isRequired,
	  bgColor: _propTypes2.default.string,
	  opacity: _propTypes2.default.number,
	  bgImages: _propTypes2.default.arrayOf(CustomPropTypes.ImageSharp),
	  imgStyle: _propTypes2.default.shape({
	    objectPosition: _propTypes2.default.string
	  })
	};
	Hero.defaultProps = {
	  tag: 'header',
	  bgColor: _vars.COLORS.bg,
	  opacity: 1,
	  bgImages: []
	};
	exports.default = (0, _styledComponents2.default)(Hero)(_templateObject2, function (props) {
	  return props.bgColor;
	}, (0, _utils.pxToRem)(_vars.MAX_CONTENT_WIDTH_PLUS), (0, _utils.pxToRem)(450), function (_ref) {
	  var isFullHeight = _ref.isFullHeight;
	  return isFullHeight ? '70vh' : '20vh';
	}, (0, _utils.pxToRem)(460));

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HeroContent = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n  z-index: 2;\n'], ['\n  position: relative;\n  z-index: 2;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(7);
	
	var CustomPropTypes = _interopRequireWildcard(_propTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var HeroContent = function HeroContent(_ref) {
	  var Tag = _ref.tag,
	      rest = _objectWithoutProperties(_ref, ['tag']);
	
	  return _react2.default.createElement(Tag, rest);
	};
	
	exports.HeroContent = HeroContent;
	HeroContent.propTypes = {
	  tag: CustomPropTypes.Tag
	};
	
	HeroContent.defaultProps = {
	  tag: 'div'
	};
	
	HeroContent.displayName = 'HeroContent';
	
	exports.default = (0, _styledComponents2.default)(HeroContent)(_templateObject);

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  padding-left: ', ';\n  padding-right: ', ';\n  width: 100%;\n  min-height: ', ';\n  height: 33%;\n  padding-bottom: 2rem;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: #fff;\n  padding-top: 1rem;\n  text-transform: uppercase;\n  font-weight: 400;\n\n  ', ', ', ' {\n    margin-bottom: 0;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  padding-left: ', ';\n  padding-right: ', ';\n  width: 100%;\n  min-height: ', ';\n  height: 33%;\n  padding-bottom: 2rem;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: #fff;\n  padding-top: 1rem;\n  text-transform: uppercase;\n  font-weight: 400;\n\n  ', ', ', ' {\n    margin-bottom: 0;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  height: 100%;\n  display: flex;\n  align-items: flex-end;\n  position: relative;\n  z-index: 2;\n'], ['\n  height: 100%;\n  display: flex;\n  align-items: flex-end;\n  position: relative;\n  z-index: 2;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _HeroContent = __webpack_require__(120);
	
	var _HeroContent2 = _interopRequireDefault(_HeroContent);
	
	var _Type = __webpack_require__(291);
	
	var _Type2 = _interopRequireDefault(_Type);
	
	var _Type3 = __webpack_require__(71);
	
	var _Type4 = _interopRequireDefault(_Type3);
	
	var _vars = __webpack_require__(5);
	
	var _utils = __webpack_require__(6);
	
	var _propTypes3 = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Content = _styledComponents2.default.hgroup(_templateObject, (0, _utils.pxToRem)(_vars.GUTTER_SIZE), (0, _utils.pxToRem)(_vars.GUTTER_SIZE), (0, _utils.pxToRem)(140), _Type2.default, _Type4.default);
	
	var HeroWithBanner = function HeroWithBanner(_ref) {
	  var title = _ref.title,
	      subtitle = _ref.subtitle,
	      Tag = _ref.tag,
	      rest = _objectWithoutProperties(_ref, ['title', 'subtitle', 'tag']);
	
	  return _react2.default.createElement(
	    Tag,
	    rest,
	    _react2.default.createElement(
	      Content,
	      null,
	      _react2.default.createElement(
	        _Type2.default,
	        { tag: 'h1', weight: 'medium' },
	        title
	      ),
	      subtitle && _react2.default.createElement(
	        _Type4.default,
	        { tag: 'h2' },
	        subtitle
	      )
	    )
	  );
	};
	
	HeroWithBanner.propTypes = {
	  title: _propTypes2.default.node,
	  subtitle: _propTypes2.default.node,
	  tag: _propTypes3.Tag
	};
	
	HeroWithBanner.defaultProps = {
	  tag: _HeroContent2.default
	};
	
	HeroWithBanner.displayName = 'HeroWithBanner';
	
	exports.default = (0, _styledComponents2.default)(HeroWithBanner)(_templateObject2);
	module.exports = exports['default'];

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Type2 = undefined;
	
	var _vars = __webpack_require__(5);
	
	var _typeComponentFactory = __webpack_require__(65);
	
	var _typeComponentFactory2 = _interopRequireDefault(_typeComponentFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var result = (0, _typeComponentFactory2.default)(_vars.TYPE_SIZE.t2, {
	  defaultTag: 'h2',
	  displayName: 'Type2'
	});
	
	var Type2 = exports.Type2 = result.Type;
	
	exports.default = result.StyledType;

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Type4 = undefined;
	
	var _vars = __webpack_require__(5);
	
	var _typeComponentFactory = __webpack_require__(65);
	
	var _typeComponentFactory2 = _interopRequireDefault(_typeComponentFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var result = (0, _typeComponentFactory2.default)(_vars.TYPE_SIZE.t4, {
	  defaultTag: 'h4',
	  displayName: 'Type4'
	});
	
	var Type4 = exports.Type4 = result.Type;
	
	exports.default = result.StyledType;

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  height: 100%;\n  z-index: 1;\n  transition: transform 3s;\n\n  &:hover {\n    transform: scale(1.15);\n  }\n'], ['\n  height: 100%;\n  z-index: 1;\n  transition: transform 3s;\n\n  &:hover {\n    transform: scale(1.15);\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n'], ['\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _GatsbyImage = __webpack_require__(64);
	
	var _GatsbyImage2 = _interopRequireDefault(_GatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ZoomImage = (0, _styledComponents2.default)(_GatsbyImage2.default)(_templateObject);
	
	var ZoomImageWrapper = function ZoomImageWrapper(_ref) {
	  var className = _ref.className,
	      rest = _objectWithoutProperties(_ref, ['className']);
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement(ZoomImage, rest)
	  );
	};
	
	ZoomImageWrapper.displayName = 'ZoomImageWrapper';
	
	ZoomImageWrapper.propTypes = {
	  className: _propTypes2.default.string
	};
	
	exports.default = (0, _styledComponents2.default)(ZoomImageWrapper)(_templateObject2);
	module.exports = exports['default'];

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withLayoutContext = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(126);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LayoutContext = _react2.default.createContext({
	  toggleElement: null,
	  displayLayoutElement: function displayLayoutElement() {},
	  hideLayoutElement: function hideLayoutElement() {},
	  scrollX: null,
	  scrollY: null
	});
	
	var withLayoutContext = function withLayoutContext(Component) {
	  var Wrapper = function (_React$Component) {
	    _inherits(Wrapper, _React$Component);
	
	    function Wrapper() {
	      _classCallCheck(this, Wrapper);
	
	      return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    Wrapper.prototype.render = function render() {
	      var _props = this.props,
	          innerRef = _props.innerRef,
	          rest = _objectWithoutProperties(_props, ['innerRef']);
	
	      return _react2.default.createElement(
	        LayoutContext.Consumer,
	        null,
	        function (layoutContext) {
	          return _react2.default.createElement(Component, _extends({ ref: innerRef }, rest, layoutContext));
	        }
	      );
	    };
	
	    return Wrapper;
	  }(_react2.default.Component);
	
	  Wrapper.displayName = 'withLayoutContext' + (Component.displayName || Component.name);
	  Wrapper.propTypes = {
	    innerRef: _propTypes2.default.func
	  };
	
	
	  (0, _hoistNonReactStatics2.default)(Wrapper, Component);
	
	  return Wrapper;
	};
	
	exports.withLayoutContext = withLayoutContext;
	exports.default = LayoutContext;

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding-left: ', ';\n  padding-right: ', ';\n\n  @media (min-width: ', ') {\n    grid-column: 2;\n  }\n'], ['\n  padding-left: ', ';\n  padding-right: ', ';\n\n  @media (min-width: ', ') {\n    grid-column: 2;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin: 0 0 1rem;\n'], ['\n  margin: 0 0 1rem;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  font-weight: ', ';\n'], ['\n  font-weight: ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  margin: 0;\n'], ['\n  margin: 0;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  @media (min-width: ', ') {\n    display: grid;\n    grid-gap: 1rem;\n    grid-auto-flow: dense;\n    grid-template-columns: 1fr ', ';\n  }\n  @media (min-width: ', ') {\n    grid-template-columns: 1fr ', ';\n  }\n'], ['\n  @media (min-width: ', ') {\n    display: grid;\n    grid-gap: 1rem;\n    grid-auto-flow: dense;\n    grid-template-columns: 1fr ', ';\n  }\n  @media (min-width: ', ') {\n    grid-template-columns: 1fr ', ';\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  padding-top: 4rem;\n  padding-bottom: 1rem;\n\n  ', ' {\n    grid-template-columns: 1fr;\n  }\n\n  ', ' {\n    cursor: pointer;\n  }\n\n  @media (min-width: ', ') {\n    ', ' {\n      grid-template-columns: repeat(auto-fit, minmax(', ', 1fr));\n    }\n\n    ', ' {\n      &:nth-child(5n + 1) {\n        grid-column: span 2;\n        grid-row: span 2;\n      }\n    }\n  }\n'], ['\n  padding-top: 4rem;\n  padding-bottom: 1rem;\n\n  ', ' {\n    grid-template-columns: 1fr;\n  }\n\n  ', ' {\n    cursor: pointer;\n  }\n\n  @media (min-width: ', ') {\n    ', ' {\n      grid-template-columns: repeat(auto-fit, minmax(', ', 1fr));\n    }\n\n    ', ' {\n      &:nth-child(5n + 1) {\n        grid-column: span 2;\n        grid-row: span 2;\n      }\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Container = __webpack_require__(119);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Gallery = __webpack_require__(305);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _GalleryItemWrapper = __webpack_require__(307);
	
	var _GalleryItemWrapper2 = _interopRequireDefault(_GalleryItemWrapper);
	
	var _ZoomImage = __webpack_require__(138);
	
	var _ZoomImage2 = _interopRequireDefault(_ZoomImage);
	
	var _GalleryItem = __webpack_require__(306);
	
	var _GalleryItem2 = _interopRequireDefault(_GalleryItem);
	
	var _List = __webpack_require__(62);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListItem = __webpack_require__(63);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Hero = __webpack_require__(134);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _GalleryOverlay = __webpack_require__(395);
	
	var _GalleryOverlay2 = _interopRequireDefault(_GalleryOverlay);
	
	var _MarkdownBlock = __webpack_require__(115);
	
	var _MarkdownBlock2 = _interopRequireDefault(_MarkdownBlock);
	
	var _HeroWithBanner = __webpack_require__(311);
	
	var _HeroWithBanner2 = _interopRequireDefault(_HeroWithBanner);
	
	var _propTypes3 = __webpack_require__(7);
	
	var CustomPropTypes = _interopRequireWildcard(_propTypes3);
	
	var _layoutContext = __webpack_require__(316);
	
	var _vars = __webpack_require__(5);
	
	var _images = __webpack_require__(140);
	
	var _images2 = _interopRequireDefault(_images);
	
	var _utils = __webpack_require__(6);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var MetaBlock = _styledComponents2.default.aside(_templateObject, (0, _utils.pxToRem)(_vars.GUTTER_SIZE), (0, _utils.pxToRem)(_vars.GUTTER_SIZE), (0, _utils.pxToRem)(1000));
	
	var MetaList = _styledComponents2.default.dl(_templateObject2);
	
	var MetaTerm = _styledComponents2.default.dt(_templateObject3, _vars.BODY_WEIGHTS.bold);
	
	var MetaDescription = _styledComponents2.default.dd(_templateObject4);
	
	var Layout = _styledComponents2.default.div(_templateObject5, (0, _utils.pxToRem)(1000), (0, _utils.pxToRem)(_vars.GRID_SIZE * 3 + _vars.GUTTER_SIZE * 2), (0, _utils.pxToRem)(1100), (0, _utils.pxToRem)(_vars.GRID_SIZE * 4 + _vars.GUTTER_SIZE * 3));
	
	var GalleryPage = function (_React$Component) {
	  _inherits(GalleryPage, _React$Component);
	
	  function GalleryPage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GalleryPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleSelectImageByIndex = function (selectedIndex) {
	      return function (event) {
	        if (event.type === 'click' || event.type === 'keypress' && (event.key === ' ' || event.key === 'Enter')) {
	          _this.props.displayLayoutElement(_GalleryOverlay2.default, {
	            selectedIndex: selectedIndex,
	            onClose: _this.props.hideLayoutElement,
	            onResetSelection: _this.props.hideLayoutElement,
	            images: (0, _images2.default)(_this.props.data.images.edges, _this.props.data.meta.frontmatter.images)
	          });
	        }
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  GalleryPage.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.props.hideLayoutElement();
	  };
	
	  GalleryPage.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        className = _props.className,
	        _props$data = _props.data;
	    _props$data = _props$data === undefined ? {} : _props$data;
	    var _props$data$meta = _props$data.meta;
	    _props$data$meta = _props$data$meta === undefined ? {} : _props$data$meta;
	    var meta = _props$data$meta.frontmatter,
	        metaContent = _props$data$meta.html,
	        imageEdges = _props$data.images,
	        background = _props$data.background;
	
	
	    var images = (0, _images2.default)(imageEdges.edges, meta.images).filter(function (_ref) {
	      var id = _ref.id;
	      return !id.includes(background.id);
	    });
	
	    if (!images) {
	      return null;
	    }
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        _Hero2.default,
	        { selectedImage: background, bgImages: [background], isFullHeight: true },
	        _react2.default.createElement(_HeroWithBanner2.default, { title: meta.name, subtitle: meta.location })
	      ),
	      _react2.default.createElement(
	        _Container2.default,
	        { plus: true, tag: 'section', className: className },
	        _react2.default.createElement(
	          Layout,
	          null,
	          _react2.default.createElement(
	            MetaBlock,
	            null,
	            _react2.default.createElement(_MarkdownBlock2.default, { dangerouslySetInnerHTML: { __html: metaContent } }),
	            _react2.default.createElement(
	              MetaList,
	              null,
	              _react2.default.createElement(
	                MetaTerm,
	                null,
	                'Client:'
	              ),
	              _react2.default.createElement(
	                MetaDescription,
	                null,
	                meta.client
	              )
	            ),
	            _react2.default.createElement(
	              MetaList,
	              null,
	              _react2.default.createElement(
	                MetaTerm,
	                null,
	                'Scope:'
	              ),
	              _react2.default.createElement(
	                MetaDescription,
	                null,
	                _react2.default.createElement(
	                  _List2.default,
	                  { decorated: true },
	                  (meta.scope || []).map(function (item) {
	                    return _react2.default.createElement(
	                      _ListItem2.default,
	                      { key: item },
	                      item
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              MetaList,
	              null,
	              _react2.default.createElement(
	                MetaTerm,
	                null,
	                'Completion Date:'
	              ),
	              _react2.default.createElement(
	                MetaDescription,
	                null,
	                meta.completionDate
	              )
	            ),
	            _react2.default.createElement(
	              MetaList,
	              null,
	              _react2.default.createElement(
	                MetaTerm,
	                null,
	                'Project Value:'
	              ),
	              _react2.default.createElement(MetaDescription, { dangerouslySetInnerHTML: { __html: meta.value } })
	            )
	          ),
	          _react2.default.createElement(
	            _Gallery2.default,
	            null,
	            images.map(function (image, i) {
	              return _react2.default.createElement(
	                _GalleryItemWrapper2.default,
	                { key: image.id },
	                _react2.default.createElement(
	                  _GalleryItem2.default,
	                  {
	                    role: 'button',
	                    tabIndex: 0,
	                    'aria-label': 'View ' + meta.name + ' photo gallery',
	                    onClick: _this2.handleSelectImageByIndex(i),
	                    onKeyPress: _this2.handleSelectImageByIndex(i)
	                  },
	                  _react2.default.createElement(_ZoomImage2.default, { sizes: image.sizes, alt: image.alt })
	                )
	              );
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return GalleryPage;
	}(_react2.default.Component);
	
	GalleryPage.displayName = 'GalleryPage';
	GalleryPage.propTypes = {
	  data: _propTypes2.default.shape({
	    meta: CustomPropTypes.GalleryMeta,
	    images: CustomPropTypes.AllImageSharp
	  }).isRequired,
	  className: _propTypes2.default.string,
	  displayLayoutElement: _propTypes2.default.func.isRequired,
	  hideLayoutElement: _propTypes2.default.func.isRequired
	};
	exports.default = (0, _styledComponents2.default)((0, _layoutContext.withLayoutContext)(GalleryPage))(_templateObject6, _Gallery2.default, _GalleryItem2.default, (0, _utils.pxToRem)(700), _Gallery2.default, (0, _utils.pxToRem)(300), _GalleryItemWrapper2.default);
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var composeImagesWithMetaData = function composeImagesWithMetaData(imageNodes, imageMeta) {
	  return imageMeta.reduce(function (acc, _ref) {
	    var imagePath = _ref.image,
	        alt = _ref.alt;
	
	    var matchImageNode = imageNodes.find(function (_ref2) {
	      var node = _ref2.node;
	      return node.id.match(imagePath);
	    });
	    if (!matchImageNode) {
	      return acc;
	    }
	    acc.push(_extends({}, matchImageNode.node, {
	      alt: alt
	    }));
	    return acc;
	  }, []);
	};
	
	exports.default = composeImagesWithMetaData;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-gallery-page-js-f57d4847194f443d08f1.js